import { createRouter, createWebHashHistory } from "vue-router";

import Layout from "@/views/Layout.vue";

const routes = [
  {
    path: "/",
    name: "主页",
    redirect: "/dashboard",
    meta: {
      title: "主页",
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Layout,
    redirect: "/dashboard/index",
    meta: {
      title: "主页",
    },
    children: [
      {
        path: "index",
        name: "index",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "主页",
        },
      },
      {
        path: "life-aeolus",
        name: "life-aeolus",
        component: () => import("@/views/home/life-aeolus.vue"),
      },
      {
        path: "newsroom/index",
        name: "newsroom",
        component: () => import("@/views/newsroom/newsroom.vue"),
      },
      {
        path: "newsroom/star-products",
        name: "star-products",
        component: () => import("@/views/newsroom/star-products.vue"),
      },
      {
        path: "newsroom/glory-days",
        name: "glory-days",
        component: () => import("@/views/newsroom/glory-days.vue"),
      },
      {
        path: "newsroom/anniversary-tribute",
        name: "anniversary-tribute",
        component: () => import("@/views/newsroom/anniversary-tribute.vue"),
      },
      {
        path: "newsroom/voice-of-aeolus-team",
        name: "voice-of-aeolus-team",
        component: () => import("@/views/newsroom/voice-of-aeolus-team.vue"),
      },
      {
        path: "contact",
        name: "contact",
        component: () => import("@/views/home/contact.vue"),
      },
      {
        path: "coming",
        name: "coming",
        component: () => import("@/views/home/coming.vue"),
      },
      {
        path: "privacy-policy",
        name: "privacy-policy",
        component: () => import("@/views/home/privacy-policy.vue"),
      },
      {
        path: "about/who-we-are",
        name: "who-we-are",
        component: () => import("@/views/about/who-we-are.vue"),
      },
      {
        path: "about/aeolus-history",
        name: "aeolus-history",
        component: () => import("@/views/about/aeolus-history.vue"),
      },
      {
        path: "products/index",
        name: "products/index",
        component: () => import("@/views/products/index.vue"),
      },
      {
        path: "products/find",
        name: "find",
        component: () => import("@/views/products/find.vue"),
      },
      {
        path: "products/truck-bus",
        name: "truck-bus",
        component: () => import("@/views/products/truck-bus.vue"),
      },
      {
        path: "products/details",
        name: "details",
        component: () => import("@/views/products/details.vue"),
      },
      {
        path: "products/sheet",
        name: "sheet",
        component: () => import("@/views/products/sheet.vue"),
      },
      {
        path: "innovation/technology",
        name: "technology",
        component: () => import("@/views/innovation/technology.vue"),
      },
      {
        path: "innovation/sustainability",
        name: "sustainability",
        component: () => import("@/views/innovation/sustainability.vue"),
      },
      {
        path: "innovation/tyre-knowledge",
        name: "tyre-knowledge",
        component: () => import("@/views/innovation/tyre-knowledge.vue"),
      },
      {
        path: "innovation/report",
        name: "report",
        component: () => import("@/views/innovation/report.vue"),
      },
      {
        path: "innovation/regulations",
        name: "regulations",
        component: () => import("@/views/innovation/regulations.vue"),
      },
      //子页面start
      {
        path: "innovation/tyre-knowledge/markings",
        name: "tyre-knowledge/markings",
        component: () => import("@/views/innovation/childPage/markings.vue"),
      },
      {
        path: "innovation/tyre-knowledge/technical-specifications",
        name: "tyre-knowledge/technical-specifications",
        component: () =>
          import("@/views/innovation/childPage/technical-specifications.vue"),
      },
      {
        path: "innovation/tyre-knowledge/inflation",
        name: "tyre-knowledge/inflation",
        component: () => import("@/views/innovation/childPage/inflation.vue"),
      },
      {
        path: "innovation/tyre-knowledge/fitting",
        name: "tyre-knowledge/fitting",
        component: () => import("@/views/innovation/childPage/fitting.vue"),
      },
      {
        path: "innovation/tyre-knowledge/alignment",
        name: "tyre-knowledge/alignment",
        component: () => import("@/views/innovation/childPage/alignment.vue"),
      },
      {
        path: "innovation/tyre-knowledge/rotation",
        name: "tyre-knowledge/rotation",
        component: () => import("@/views/innovation/childPage/rotation.vue"),
      },
      {
        path: "innovation/tyre-knowledge/braking",
        name: "tyre-knowledge/braking",
        component: () => import("@/views/innovation/childPage/braking.vue"),
      },
      {
        path: "innovation/tyre-knowledge/suspension",
        name: "tyre-knowledge/suspension",
        component: () => import("@/views/innovation/childPage/suspension.vue"),
      },
      {
        path: "innovation/tyre-knowledge/safety-tips",
        name: "tyre-knowledge/safety-tips",
        component: () => import("@/views/innovation/childPage/safety-tips.vue"),
      },
      //子页面end
      {
        path: "innovation/services",
        name: "services",
        component: () => import("@/views/innovation/services.vue"),
      },
    ],
  },
  {
    path: "/structure",
    name: "股权架构",
    component: () => import("@/views/structure/index.vue"),
    meta: {
      title: "股权架构",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.afterEach(() => {
  window.scrollTo(0, 0); // 滚动条滚动到顶部
});
export default router;
